var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{attrs:{"id":"c1"}}),_c('p',{staticClass:"list"},[_vm._v(_vm._s(_vm.name)+"欢迎您登录响贝管理系统。")]),_c('p',{staticClass:"list"},[_vm._v(_vm._s(_vm.getCurrentDate(2))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }